/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignPipelineConfigDestroyStagePathParams,
	CampaignPipelineConfigDestroyStageQueryParams,
	CampaignPipelineConfigDestroyStageResponse,
} from '../types/CampaignPipelineConfigDestroyStage'

/**
 * DELETE /campaigns/:campaign/pipeline-config/stages/:stageId
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::destroyStage
 */
export async function campaignPipelineConfigDestroyStage(
	campaign: CampaignPipelineConfigDestroyStagePathParams['campaign'],
	stageId: CampaignPipelineConfigDestroyStagePathParams['stageId'],
	params?: CampaignPipelineConfigDestroyStageQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignPipelineConfigDestroyStageResponse>> {
	return axiosInstance.delete(`/campaigns/${campaign}/pipeline-config/stages/${stageId}`, { params, ...config })
}
